






import Vue from 'vue';

export default Vue.extend({
    methods: {
    },
    created() {
    },
});
